import { render, staticRenderFns } from "./Empty-Layout.vue?vue&type=template&id=1482b740&scoped=true&"
import script from "./Empty-Layout.vue?vue&type=script&lang=js&"
export * from "./Empty-Layout.vue?vue&type=script&lang=js&"
import style0 from "./Empty-Layout.vue?vue&type=style&index=0&id=1482b740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482b740",
  null
  
)

export default component.exports